import React from "react";
import "./Partners.css";

const partnersList  = [
  { name: "TÜBİTAK", logo: "/partners/tubitak.svg" },
  { name: "ALARKO", logo: "/partners/alarko.svg" },
  { name: "ÜNLÜ & Co", logo: "/partners/unlu-co.jpeg" },
  { name: "Hamilik Okulu", logo: "/partners/hamilik-okulu-girisimcilik.jfif" },
  { name: "TEKNOFEST", logo: "/partners/teknofest.png" },
  { name: "İNOVATİM", logo: "/partners/inovatim.png" },
  { name: "BTM", logo: "/partners/btm.svg" },
  { name: "KAGİDER", logo: "/partners/kagider.png" },
  { name: "TİM", logo: "/partners/tim.png" },
  { name: "TEB", logo: "/partners/teb.svg" },
  { name: "ENTERTECH", logo: "/partners/entertech.png" },
  { name: "İTÜ Çekirdek", logo: "/partners/itu-cekirdek.png" },
  { name: "MMG", logo: "/partners/mmg.png" },
  { name: "MÜSİAD", logo: "/partners/musiad.webp" },
  { name: "Girişim Öncüleri", logo: "/partners/girisim-onculeri.png" },
  { name: "Şişli Etfal Hastanesi", logo: "/partners/sisli-hastane.png" },
];

const Partners  = () => {
  return (
    <section className="partners-section">
      <div className="partners-container">
        <h2 className="partners-title">
          Bilimsel ve Kurumsal <span>İşbirliklerimiz</span>
        </h2>
        <p className="partners-subtitle">
          Güçlü paydaşlarımız ile birlikte geliştiriyoruz.
        </p>
      </div>
      <div className="partners-marquee">
        <div className="partners-track">
          {[...partnersList, ...partnersList].map((partner, idx) => (
            <div className="partner-item" key={idx}>
              <img
                src={partner.logo}
                alt={partner.name}
                className="partner-logo"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners ;
